<div>
    <p-progressSpinner></p-progressSpinner>
    <p>redirecting...</p>
</div>